import { render, staticRenderFns } from "./AdminStatsTable.vue?vue&type=template&id=bb67d53c&scoped=true&"
import script from "./AdminStatsTable.vue?vue&type=script&lang=js&"
export * from "./AdminStatsTable.vue?vue&type=script&lang=js&"
import style0 from "./AdminStatsTable.vue?vue&type=style&index=0&id=bb67d53c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb67d53c",
  null
  
)

export default component.exports